import request from 'superagent';

import Model from '../model';

import selector from './selector';
import * as actions from './actions';

class Exchange extends Model {
    constructor(props){
        super(props)
        this.selector = selector
    }

    read() {
        const selectorFunction = {
                'options': (state) => selector.getOptions(state).toJS(),
                'network': (state) => this.networkSelector.get(state, 'exchange read').toJS()
        }

        const dispatchFunction = () => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch(actions.exchangeReadRequested())
                request
                .post(`${url}/v2/api/exchange/read`)
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.exchangeReadSucceeced(res.body.options))
                    }else{
                        dispatch(actions.exchangeReadFailed(err, res))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }
    create(){
        const selectorFunction = () => ({
                'options': (state) => selector.getOptions(state).toJS(),
                'network': (state) => this.networkSelector.get(state, 'exchange create').toJS()
        })

        const dispatchFunction = ({label, parent_id}) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch(actions.exchangeCreateRequested())
                request
                .post(`${url}/v2/api/exchange/create`)
                .send({label, parent_id})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.exchangeCreateSucceeded(res.body.options))
                    }else{
                        dispatch(actions.exchangeCreateFailed(err, res))
                    }
                })
            }
        }

        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }
    update(){
        const selectorFunction = () => ({
                'options': (state) => selector.getOptions(state).toJS(),
                'network': (state) => this.networkSelector.get(state, 'exchange update').toJS()
        })

        const dispatchFunction = ({option_id, label, visible}) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch(actions.exchangeCreateRequested())
                request
                .post(`${url}/v2/api/exchange/update`)
                .send({option_id, label, visible})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.exchangeUpdateSucceeded(res.body.options))
                    }else{
                        dispatch(actions.exchangeUpdateFailed(err, res))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }
    updates(){
        const selectorFunction = () => ({
                'options': (state) => selector.getOptions(state).toJS(),
                'network': (state) => this.networkSelector.get(state, 'exchange updates').toJS()
        })

        const dispatchFunction = (options) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch(actions.exchangeUpdatesRequested())
                request
                .post(`${url}/v2/api/exchange/updates`)
                .send({options})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.exchangeUpdatesSucceeded(res.body.options))
                    }else{
                        dispatch(actions.exchangeUpdatesFailed(err, res))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }
    delete(){
        const selectorFunction = {
                'options': (state) => selector.getOptions(state).toJS(),
                'network': (state) => this.networkSelector.get(state, 'exchange delete').toJS()
        }
        const dispatchFunction = (option_id) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                dispatch(actions.exchangeDeleteRequested())
                request
                .post(`${url}/v2/api/exchange/delete`)
                .send({option_id})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.exchangeDeleteSucceeded(res.body.options))
                        this.toast.success("Kanal togs bort")
                    }else{
                        dispatch(actions.exchangeDeleteFailed(err, res))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }

}
export default new Exchange();



// WEBPACK FOOTER //
// ./src/model/Exchange/model.js